import React, { useState } from "react";
import { MyButton } from "../components/Button";
import { Button } from "@mui/material";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import { StepperConnector, StepperStepIcon } from "../components/Stepper";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import StepLabel from "@mui/material/StepLabel";
import Step from "@mui/material/Step";
import FormScreenOne from "../components/FormScreen1";
import FormScreenTwo from "../components/FormScreen2";
import FormScreenThree from "../components/FormScreen3";
import FormScreenFour from "../components/FormScreen4";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";

const FormScreen = () => {
  const navigate = useNavigate();
  const steps = ["", "", "", ""];
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set());

  const formRef = React.useRef();

  const [formData, setFormData] = React.useState({
    name: "",
    phone: "",
    email: "",
    dob: "",
    gender: "",
    localCom: "",
    title: "",
    isFirstConf: "",
    social: "",
    allergies: "",
    medicals: "",
    sameSexRoomie: "",
    emergencyPhone: "",
    emergencyRelation: "",
    expectations: "",
    suggestions: "",
  });

  const [formErrors, setFormErrors] = React.useState({
    nameError: "",
    phoneError: "",
    emailError: "",
    dobError: "",
    genderError: "",
    localComError: "",
    titleError: "",
    isFirstConfError: "",
    socialError: "",
    allergiesError: "",
    medicalsError: "",
    sameSexRoomieError: "",
    emergencyPhoneError: "",
    emergencyRelationError: "",
    expectationsError: "",
    suggestionsError: "",
  });

  const handleChange = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const [isLoading, setIsLoading] = React.useState(false);

  const handleSubmit = () => {
    // e.preventDefault();
    if (!formRef.current.checkValidity()) {
      toast.warning("You have empty field(s)");
      return;
    }
    setIsLoading(true);
    axios
      .post("https://nc-ibadan.fly.dev/register", formData)
      .then((res) => {
        navigate("/form/done");
      })
      .catch((err) => {
        toast.warning("You have errors in your forms");
      });
    setIsLoading(false);
  };

  const isStep = (step) => {
    return step === 1;
  };

  const isStepSkipped = (step) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <Box>
      <Container sx={{ width: "100%", height: "100vh", position: "absolute" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-end",
            //   flexDirection: "column",
            width: "100%",
            height: "100%",
          }}
        >
          <Typography
            sx={{
              fontWeight: 700,
              fontSize: "15em",
              color: "#461152",
              opacity: 0.47,
              position: "fixed",
              marginRight: { xs: "0", md: "60px" },
            }}
          >
            {`0${activeStep + 1}`}
          </Typography>
        </Box>
      </Container>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <Typography
          sx={{
            mt: { xs: "2rem", md: "3rem" },
            mb: { xs: "1rem", md: "1rem" },
            fontWeight: 900,
            letterSpacing: "5px",
            textTransform: "uppercase",
            textAlign: "center",
          }}
        >
          19th October - 24th October
        </Typography>
        <Box
          sx={{
            width: { xs: "85%", md: "40%" },
            // height: { xs: "65vh", md: "80vh" },
            backgroundColor: "#56109C1A",
            border: "0.5px solid #F8F7F999",
            textAlign: "center",
            padding: "10px 10px",
          }}
        >
          <Typography
            sx={{
              fontSize: "1.5rem",
              fontWeight: 600,
            }}
          >
            <span style={{ color: "#EDAD4D", fontWeight: 700 }}>Hope is</span>{" "}
            the only thing{" "}
            <span style={{ color: "#EDAD4D", fontWeight: 700 }}>stronger </span>
            than fear
          </Typography>
          <Typography
            sx={{
              fontWeight: { xs: 700, md: 500 },
              mt: { xs: "1rem", md: "0" },
            }}
          >
            Get identified ({activeStep + 1}/4)
          </Typography>
          <Box
            component="form"
            // onSubmit={handleSubmit}
            ref={formRef}
            noValidate
            autoComplete="off"
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              mt: "1rem",
            }}
          >
            <Stack
              sx={{
                width: { xs: "100%", md: "80%" },
                mt: { xs: "1rem", md: "0" },
                mb: { xs: "1rem", md: "0" },
              }}
            >
              <Stepper activeStep={activeStep} connector={<StepperConnector />}>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel StepIconComponent={StepperStepIcon}>
                      {label}
                    </StepLabel>
                  </Step>
                ))}
              </Stepper>
            </Stack>
            <Box
              sx={{
                mt: "1rem",
                padding: { xs: "0 0.5rem", md: "0 3rem" },
              }}
            >
              {activeStep === 0 ? (
                <>
                  <FormScreenOne
                    formData={formData}
                    formErrors={formErrors}
                    handleChange={handleChange}
                  />
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "end",
                    }}
                  >
                    <MyButton
                      sx={{
                        mt: { xs: "2em", md: "1em" },
                        marginRight: { xs: "-0.2rem", md: "-2.5rem" },
                        backgroundColor: "#fff",
                      }}
                      onClick={handleNext}
                    >
                      <Box
                        sx={{
                          width: { xs: "15px", md: "10px" },
                          height: { xs: "15px", md: "10px" },
                          backgroundColor: "#591A68",
                          marginRight: { xs: "30px", md: "30px" },
                        }}
                      ></Box>
                      Next
                      <Box
                        sx={{
                          width: { xs: "15px", md: "10px" },
                          height: { xs: "15px", md: "10px" },
                          backgroundColor: "#591A68",
                          marginLeft: { xs: "30px", md: "30px" },
                        }}
                      ></Box>
                    </MyButton>
                  </Box>
                </>
              ) : (
                <>
                  {activeStep === 1 ? (
                    <>
                      <FormScreenTwo
                        formData={formData}
                        formErrors={formErrors}
                        handleChange={handleChange}
                      />
                      <Box
                        sx={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <Button
                          variant="text"
                          sx={{
                            mt: { xs: "2em", md: "1em" },
                            marginLeft: { xs: "0", md: "-3rem" },
                            backgroundColor: "transparent",
                            color: "#fff",
                            textTransform: "capitalize",
                            fontWeight: 600,
                            fontSize: "1rem",
                          }}
                          onClick={handleBack}
                        >
                          Prev
                        </Button>
                        <MyButton
                          sx={{
                            mt: { xs: "2em", md: "1em" },
                            marginRight: { xs: "-0.2rem", md: "-2.5rem" },
                            backgroundColor: "#fff",
                          }}
                          onClick={handleNext}
                        >
                          <Box
                            sx={{
                              width: { xs: "15px", md: "10px" },
                              height: { xs: "15px", md: "10px" },
                              backgroundColor: "#591A68",
                              marginRight: { xs: "30px", md: "30px" },
                            }}
                          ></Box>
                          Next
                          <Box
                            sx={{
                              width: { xs: "15px", md: "10px" },
                              height: { xs: "15px", md: "10px" },
                              backgroundColor: "#591A68",
                              marginLeft: { xs: "30px", md: "30px" },
                            }}
                          ></Box>
                        </MyButton>
                      </Box>
                    </>
                  ) : (
                    <>
                      {activeStep === 2 ? (
                        <>
                          <FormScreenThree
                            formData={formData}
                            formErrors={formErrors}
                            handleChange={handleChange}
                          />
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Button
                              variant="text"
                              sx={{
                                mt: { xs: "2em", md: "1em" },
                                marginLeft: { xs: "0", md: "-3rem" },
                                backgroundColor: "transparent",
                                color: "#fff",
                                textTransform: "capitalize",
                                fontWeight: 600,
                                fontSize: "1rem",
                              }}
                              onClick={handleBack}
                            >
                              Prev
                            </Button>
                            <MyButton
                              sx={{
                                mt: { xs: "2em", md: "1em" },
                                marginRight: { xs: "-0.2rem", md: "-2.5rem" },
                                backgroundColor: "#fff",
                              }}
                              onClick={handleNext}
                            >
                              <Box
                                sx={{
                                  width: { xs: "15px", md: "10px" },
                                  height: { xs: "15px", md: "10px" },
                                  backgroundColor: "#591A68",
                                  marginRight: { xs: "30px", md: "30px" },
                                }}
                              ></Box>
                              Next
                              <Box
                                sx={{
                                  width: { xs: "15px", md: "10px" },
                                  height: { xs: "15px", md: "10px" },
                                  backgroundColor: "#591A68",
                                  marginLeft: { xs: "30px", md: "30px" },
                                }}
                              ></Box>
                            </MyButton>
                          </Box>
                        </>
                      ) : (
                        <>
                          <FormScreenFour
                            formData={formData}
                            formErrors={formErrors}
                            handleChange={handleChange}
                          />
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "space-between",
                            }}
                          >
                            <Button
                              variant="text"
                              sx={{
                                mt: { xs: "2em", md: "1em" },
                                marginLeft: { xs: "0", md: "-3rem" },
                                backgroundColor: "transparent",
                                color: "#fff",
                                textTransform: "capitalize",
                                fontWeight: 600,
                                fontSize: "1rem",
                              }}
                              disabled={isLoading}
                              onClick={handleBack}
                            >
                              Prev
                            </Button>
                            <MyButton
                              sx={{
                                mt: { xs: "2em", md: "1em" },
                                marginRight: { xs: "0rem", md: "-2.5rem" },
                                backgroundColor: "#fff",
                                letterSpacing: { xs: "2px", md: "8px" },
                              }}
                              disabled={isLoading}
                              onClick={handleSubmit}
                              // type="submit"
                            >
                              <Box
                                sx={{
                                  width: { xs: "15px", md: "10px" },
                                  height: { xs: "15px", md: "10px" },
                                  backgroundColor: "#591A68",
                                  marginRight: { xs: "20px", md: "30px" },
                                }}
                              ></Box>
                              Identify Me
                              <Box
                                sx={{
                                  width: { xs: "15px", md: "10px" },
                                  height: { xs: "15px", md: "10px" },
                                  backgroundColor: "#591A68",
                                  marginLeft: { xs: "20px", md: "30px" },
                                }}
                              ></Box>
                            </MyButton>
                          </Box>
                        </>
                      )}
                    </>
                  )}
                </>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default FormScreen;
